import React from 'react';
import RequireUnlogged from './RequireUnlogged';
import dynamic from 'next/dynamic';

// RequireAuth needs to be disconnected from SSR as it creates hydration issues
// This should be solved by using a different way to perform user checks / user login
// with server side login and using getServerSideProps
const RequireAuth = dynamic(() => import('./RequireAuth'), {ssr: false});

type RouteGuardProps = {
	children: React.ReactNode;
	unlogged?: boolean;
	logged?: boolean;
	right?: string;
	userTypeRestriction?: number[];
};

const RouteGuard = ({
	children,
	unlogged,
	logged,
	right,
	userTypeRestriction,
}: RouteGuardProps) => {
	if (unlogged) {
		return <RequireUnlogged>{children}</RequireUnlogged>;
	}

	if (logged) {
		return (
			<RequireAuth right={right} userTypeRestriction={userTypeRestriction}>
				{children}
			</RequireAuth>
		);
	}

	return <React.Fragment>{children}</React.Fragment>;
};

export default RouteGuard;
